import React from 'react'

const DeleteProfile = () => {
    return (
        <>
            <meta charSet="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Eapro</title>
            <link
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.4/dist/css/bootstrap.min.css"
                rel="stylesheet"
            />
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        "\n    body {\n      font-family: Arial, sans-serif;\n      background-color: #f8f9fa;\n      padding: 20px;\n    }\n\n    header {\n      text-align: center;\n      padding-bottom: 30px;\n    }\n\n    .Title {\n      font-size: 2.5rem;\n      font-weight: bold;\n      border-bottom: 2px solid rgb(201, 169, 66);\n      display: inline-block;\n      padding-bottom: 10px;\n    }\n\n    .container {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 20px;\n      justify-content: center;\n    }\n\n    .content {\n      background: white;\n      padding: 20px;\n      border-radius: 10px;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n      flex: 1 1 calc(50% - 20px);\n      max-width: calc(50% - 20px);\n    }\n\n    .step-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 15px;\n      margin-bottom: 10px;\n    }\n\n    .step-number {\n      background-color: black;\n      color: white;\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 1.2rem;\n      flex-shrink: 0;\n    }\n\n    .step-title {\n      font-weight: bold;\n      margin: 0;\n      font-size: 1.25rem;\n    }\n\n    img {\n      width: 100%;\n      height: auto;\n      border-radius: 10px;\n      margin-top: 10px;\n    }\n\n    footer {\n      border-top: 1px solid rgb(201, 169, 66);\n      text-align: center;\n      margin: 50px auto 0;\n      padding-top: 20px;\n    }\n\n   #logo{\n    width: 350px;\n    /* height:100px; */\n   }\n    @media (max-width: 768px) {\n      .content {\n        flex: 1 1 100%;\n        max-width: 100%;\n      }\n      #logo{\n    width: 250px;\n    /* height:100px; */\n   }\n    }\n  "
                }}
            />
            <header>
                <p className="Title">Delete account on mobile app</p>
            </header>
            <div className="container">
                <div className="content">
                    <div className="step-wrapper">
                        <div className="step-number">1</div>
                        <h2 className="step-title">Go to Navigation</h2>
                    </div>
                    <img src="images/delete-profile/10000699952.jpg" alt="Navigation screen" />
                </div>
                <div className="content">
                    <div className="step-wrapper">
                        <div className="step-number">2</div>
                        <h2 className="step-title">Choose delete profile</h2>
                    </div>
                    <img src="images/delete-profile/10000699962.jpg" alt="Delete profile icon screen" />
                </div>
                <div className="content">
                    <div className="step-wrapper">
                        <div className="step-number">3</div>
                        <h2 className="step-title">Enter reason for deleting account</h2>
                    </div>
                    <img src="images/delete-profile/10000699971.jpg" alt="Reason input screen" />
                </div>
                <div className="content">
                    <div className="step-wrapper">
                        <div className="step-number">4</div>
                        <h2 className="step-title">Enter received OTP</h2>
                    </div>
                    <img src="images/delete-profile/10000699981.jpg" alt="OTP entry screen" />
                    <h5 className="text-center mt-3">
                        An OTP will be sent to your registered mobile number. Enter the OTP to
                        confirm deletion.
                    </h5>
                </div>
                <div className="content">
                    <div className="step-wrapper">
                        <div className="step-number">5</div>
                        <h2 className="step-title">Press Confirm button</h2>
                    </div>
                    <img src="images/delete-profile/10000699982.jpg" alt="Confirmation screen" />
                    <h5 className="text-center mt-3">
                        All of the data associated with your account will be permanently
                        deleted.
                    </h5>
                </div>
            </div>
            <footer>
                <img id="logo" src="images/delete-profile/logo (2).png" alt="" />
            </footer>
        </>

    )
}

export default DeleteProfile